import https from '@sg/utils/httpC';

// Overview
export const getDecisionPointsList = (payload: {
  start_date: string,
  end_date: string
}): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/overview/decision_points/list',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getOverviewData = (payload?: { datatime?: string }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/executive-summary',
  method: 'post',
  data: payload || {},
  rawData: true,
});

export const getGrossRevenueTrend = (payload?: { datatime?: string }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/monthly-revenue',
  method: 'post',
  data: payload || {},
  rawData: true,
});

export const getGrossRevenueByProject = (payload?: { datatime?: string }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/projects',
  method: 'post',
  data: payload || {},
  rawData: true,
});

export const updateGrossRevenueByProject = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/projects/batch-update',
  method: 'post',
  data: payload,
  rawData: true,
});

// MKT Cost
export const getMktCostExecutiveSummary = (payload?: { datatime?: string | null }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/mkt_cost/executive-summary',
  method: 'post',
  data: payload || {},
  rawData: true,
});

export const getMktCostCalendarProjects = (payload: { top_num?: number; search?: string }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/mkt_cost/calendar/project/list',
  method: 'post',
  data: payload,
  rawData: true,
});

// Get MKT Cost Add Project list
export const getMktCostProjectList = (): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/mkt_cost/list',
  method: 'post',
  data: {},
  rawData: true,
});

// Add project to MKT Cost Calendar
export const addProjectToMktCostCalendar = (payload: {
  game_id: string;
}): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/mkt_cost/calendar/project/add',
  method: 'post',
  data: payload,
  rawData: true,
});

export const updateDecisionPoints = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/overview/decision_points/update',
  method: 'post',
  data: payload,
  rawData: true,
});

export const deleteDecisionPoints = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/overview/decision_points/delete',
  method: 'post',
  data: payload,
  rawData: true,
});


export const addProjectOptions = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/overview/decision_points/project/add',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getProjectOptionsList = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/overview/decision_points/project/list',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getMktCostCalendarList = (payload: {
  start_date: string,
  end_date: string
}): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/mkt_cost/calendar/list',
  method: 'post',
  data: payload,
  rawData: true,
});

export const updateMktCostCalendar = (payload: {
  start_date: string;
  end_date: string;
  data: Array<{
    date: string;
    game_id: string;
    name: string;
    status: string;
    remark: string;
  }>;
}): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/mkt_cost/calendar/update',
  method: 'post',
  data: payload,
  rawData: true,
});

export const deleteMktCostCalendarCard = (payload: { id: number }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/mkt_cost/calendar/delete',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getMktCostByProject = (payload?: { datatime?: string | null }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/mkt_cost/projects',
  method: 'post',
  data: payload || {},
  rawData: true,
});

export const updateMktCostProjects = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/mkt_cost/projects/batch-update',
  method: 'post',
  data: payload,
  rawData: true,
});

// Headcount
export const getPublishingHeadcountCapsule = (payload: { datatime?: string } = {}): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/hc/headcount',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getHeadcountProjects = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/hc/projects',
  method: 'post',
  data: payload,
  rawData: true,
});

export const updatePublishingHeadcountProjects = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/hc/projects/batch-update',
  method: 'post',
  data: payload,
  rawData: true,
});

// Publishing Projects
export const getMktCostBudgetTotal = (payload: { projectId: string }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/publishing_project/mkt-cost',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getProjectGrossRevenue = (payload: { projectId: string }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/publishing_project/gross_revenue',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getProjectTechCost = (payload: { projectId: string }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/publishing_project/tech_cost',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getProjectReviews = (payload: { projectId: string }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/publishing_project/reviews',
  method: 'post',
  data: payload,
  rawData: true,
});

export const updateProjectReview = (payload: {
  id: number;
  description: string;
  documents: string[];
  file_name: string[];
}): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/publishing_project/reviews/update',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getPublishingProjectsList = (): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/projects-list',
  method: 'post',
  data: {},
  rawData: true,
});

export const getHeadcountTrend = (payload: { datatime?: string } = {}): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/hc/trend',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getPublishingProjectHeadcount = (payload: { project_id: string }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/publishing/headcount',
  method: 'post',
  data: payload,
  rawData: true,
});
